import React, { useState } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Copy } from 'components/components/atoms';
import { Container } from 'components/shared';

import loadable from '@loadable/component';
const ContactCustomerCarePanel = loadable(() =>
  import('components/components/organisms/ContactCustomerCarePanel'),
);
const ContactMarketCardsPanel = loadable(() =>
  import('components/components/organisms/ContactMarketCardsPanel'),
);
const getFields = (rendering, name) => {
  try {
    const { placeholders } = rendering;
    const componentFields = placeholders[name][0];
    return componentFields;
  } catch (e) {
    return null;
  }
};
const getCustomerCare = (selectedMarket, contactInformationPanel) => {
  try {
    const customerCare = getFieldValue(contactInformationPanel, 'customerCare');
    return (
      customerCare && customerCare.filter((s) => s.market === selectedMarket)
    );
  } catch (e) {
    return null;
  }
};
const getStateAbreviation = (selectedMarket, marketCards) => {
  if (selectedMarket && marketCards && marketCards.length > 0) {
    const market = marketCards.find((m) => m.name === selectedMarket);
    const stateLabel = market && market.state;
    const stateAbreviation = stateLabel && stateLabel.split(',');
    return stateAbreviation && stateAbreviation[1];
  }
  return '';
};
const MarketCardsWrapper = ({ rendering }) => {
  const marketCards = getFields(rendering, 'markets-cards');
  const contactInformationPanel = getFields(rendering, 'contact-panel');
  const marketCardsList = getFieldValue(marketCards, 'marketCards');
  const customerCareTitle =
    contactInformationPanel &&
    getFieldValue(contactInformationPanel, 'customerCareTitle');
  const [hasCustomeCare, setHasCustomeCare] = useState(false);
  const [marketSelected, setMarketSelected] = useState();
  const [stateAbreviation, setStateAbreviation] = useState();
  const [customeCareInfo, setCustomeCareInfo] = useState();

  const handleMarketCardClick = (selectedMarket) => {
    if (selectedMarket) {
      setMarketSelected(selectedMarket);
      setStateAbreviation(getStateAbreviation(selectedMarket, marketCardsList));
      const customerCare = getCustomerCare(
        selectedMarket,
        contactInformationPanel,
      );

      if (customerCare && customerCare.length > 0) {
        setHasCustomeCare(true);
        setCustomeCareInfo(customerCare);
      } else {
        setHasCustomeCare(false);
        setCustomeCareInfo();
      }
    } else {
      setMarketSelected();
      setHasCustomeCare(false);
    }
  };
  if (!contactInformationPanel || !marketCards) return null;
  return (
    <div className='py-16'>
      <ContactMarketCardsPanel
        fields={marketCards}
        contactPanelFields={contactInformationPanel}
        handleMarketCardClick={handleMarketCardClick}
      />
      <div className='h-8 md:h-0'></div>
      {hasCustomeCare && (
        <ContactCustomerCarePanel
          stateAbreviation={stateAbreviation}
          customerCareTitle={customerCareTitle}
          marketSelected={marketSelected}
          customeCareInfo={customeCareInfo}
        />
      )}
      {!hasCustomeCare && marketSelected && (
        <>
          <Container className='items-left'>
            <Copy
              className={
                'text-lg mt-3 md:mt-6 md:text-2xl leading-7 font-graphie text-mattamy-blue text-left'
              }
            >
              {'No contacts available at the moment.'}
            </Copy>
          </Container>
        </>
      )}
    </div>
  );
};

export default MarketCardsWrapper;
